import axios from 'axios'

export default async () => {
  let res = await axios.get('priceList')

  return res.data
}



// WEBPACK FOOTER //
// ./src/api/priceList.js